import type { Hco } from '@/core/graphql/generated/types';

type SectionValuesType =
	| keyof Hco
	| 'hcoTypeLocal_VId'
	| 'typeOfHierarchy_VId'
	| 'countHcp_VId'
	| 'countPrescriber_VId'
	| 'allSpecLocal_VId'
	| 'hcoOwnership_VId'
	| 'academicStatus_VId';

export const HcoDcrSectionFields: Record<string, SectionValuesType[]> = {
	Name: ['hcoNameCda_V'],

	Organizational: [
		'hcoType',
		'hcoTypeLocal_VId',
		'allSpecLocal_VId',
		'countHcp_VId',
		'countPrescriber_VId',
		'businessType_V',
		'hcoOwnership_VId',
		'academicStatus_VId',
		'vaDodAffiliated_V',
		'statusCda_V'
	],

	IDs: ['nhidCda_V', 'hcoTaxId_V'],

	Contact: ['officePhoneCda_V', 'faxCda_V', 'emailCda_V', 'websiteCda_V'],

	Hierarchy: ['typeOfHierarchy_VId'],

	Affiliations: ['parenthcos'],

	Addresses: ['addresses']
};
